import React, { useEffect } from 'react';
import {
  useDispatch,
  useSelector
}                           from "react-redux";
import service              from "../../../services";

import { ApplicationState } from "../../../store";
import { APIState }         from "../../../store/API/types";
import {
  errorBookmarkForPane,
  successBookmarkForPane
}                           from "../../../store/bookmarks/actions";
import { BookmarkState }    from "../../../store/bookmarks/types";
import { LayoutState }      from "../../../store/layouts/types";
import {
  getTimeline,
  setTimelineDate
}                           from "../../../store/timeline/actions";
import {
  getLocalBounds,
  successPaneTime
}                           from "../../../utils";
import ImagePaneComponent   from "../../reusable/ImagePaneComponent";
import NoVideoComponent     from "../../reusable/NoVideoComponent";
import PaneTimeComponent    from "../../reusable/PaneTimeComponent";
import SpinnerComponent     from "../../reusable/SpinnerComponent";
import ZoomComponent        from "../../reusable/ZoomComponent";

interface Props {
  pane: number,
  refContainer: any,
  refImg: any,
  src: string | null,
  error: boolean,
  success: boolean,
  inited: boolean,
  fetch: boolean,
  name: undefined | string,
  doExpand: (e: React.MouseEvent) => void,
}

const BookmarksPaneComponent: React.FC<Props> = ({pane, refContainer, src, error, success, fetch, refImg, doExpand, inited, name}) => {
  const {checkedPane} = useSelector<ApplicationState, LayoutState>(state => state.layouts);
  const {expanded, bookmarks} = useSelector<ApplicationState, BookmarkState>(state => state.bookmarks);
  const {token} = useSelector<ApplicationState, APIState>(state => state.API);
  const dispatch = useDispatch();
  const titleClassValue = checkedPane === pane ? 'camera-title checked' : 'camera-title';

  const bkm = bookmarks[pane]
    ? bookmarks[pane]
    : null;

  const onload = () => {
    dispatch(successBookmarkForPane(pane));
    setCurrentBookmarkTimeline();
    successPaneTime(pane);
  };

  const onerror = (el: HTMLImageElement | null | undefined) => {
    if (el && el.src.indexOf('bookmarks') === -1) {
      dispatch(errorBookmarkForPane(pane))
    }
  };

  const setCurrentBookmarkTimeline = () => {
    if (bkm?.timeBounds && (pane === 0 || pane === 1)) {
      const {start, end} = bkm.timeBounds;
      if (pane === checkedPane) {
        dispatch(setTimelineDate(start));
      }
      dispatch(getTimeline(pane, start, end, null));
    }
  }

  useEffect(() => {
    if (pane === checkedPane) {
      setCurrentBookmarkTimeline();
    }
  }, [checkedPane]);

  return (
    <div className='pos-rel w-100 h-100 o-hidden'
         ref={refContainer}
    >
      {
        (src && !error) &&
        <>
          <ZoomComponent enable={checkedPane === pane && !src}
                         pane={pane}
          >
            <div className='w-100 h-100 flex al-it-c js-c'>
              <ImagePaneComponent pane={pane}
                                  src={src}
                                  className={'thumbnail-pane'}
                                  alt={'thumbnail-pane-' + pane}
                                  onload={onload}
                                  onerror={onerror}
              />
              {
                bkm && <PaneTimeComponent time={bkm.timeBounds.start} pane={pane}/>
              }
            </div>
          </ZoomComponent>
        </>
      }
      {
        name && <div className={expanded !== null ? `${titleClassValue} zoomed` : `${titleClassValue}`}
                     onMouseDown={doExpand}
        >
          {name}
        </div>
      }

      {
        !success && <div className='w-100 h-100 flex al-it-c js-c'>
          {fetch || inited && !success && <SpinnerComponent/>}
          {error && <NoVideoComponent/>}
        </div>
      }
    </div>
  )
};

export default BookmarksPaneComponent;